import { TenantGroup } from "../../tenants-groups/models/tenant-group.model";
import { UserRoleType } from "../enums/user-role-type.enum";
import { User } from '@done/ngx-essentials';

export class UserRole {
    // id!: number;
    // // TODO WL: Ajustar propriedade no back-end
    // userId!: string;
    // user?: User;
    // profile!: string;
    // type!: UserRoleType;
    // tenantGroupId?: number;
    // tenantGroup?: TenantGroup;
    // // TODO WL: Ajustar propriedade no back-end
    // responsibleId?: string;
    // responsible?: User;

    profile!: string;
    responsibleId?: string;

}